import { HttpClient, HttpParams } from '@angular/common/http';
import { Component, inject } from '@angular/core';
import { ActivatedRoute, Router, UrlSegment } from '@angular/router';
import { lastValueFrom, map, Observable } from 'rxjs';
import { API_URL_V4, environment } from 'src/environments/environment.local';

@Component({
  standalone: true,
  template: '',
})
export class V2RedirectComponent {
  private route: ActivatedRoute = inject(ActivatedRoute);
  private router: Router = inject(Router);
  private http: HttpClient = inject(HttpClient);

  ngOnInit() {
    this.route.url.subscribe(async (urlSegments: UrlSegment[]) => {
      this.redirectTo(await this.urlFilter(urlSegments));
    });
  }

  async urlFilter(urlSegments: UrlSegment[]): Promise<string> {
    if (urlSegments[0].path === 'content') {
      const hashId: string = urlSegments[1].path;
      const type: 'coaching' | 'watch' =
        urlSegments[1].path.length === 7 ? 'coaching' : 'watch';
      const id: number = await lastValueFrom(this.getContentId(type, hashId));
      return `/browse/${type}/${id}`;
    }

    const path: string = urlSegments
      .map((seg: UrlSegment) => seg.path)
      .join('/');

    /**
     * liste des urls à traiter
     * https://www.kinomap.com/v2/home
     * https://www.kinomap.com/v2/dashboard
     * https://www.kinomap.com/v2/compatibility
     * https://www.kinomap.com/v2/dashboard/my-profile
     * https://www.kinomap.com/v2/register
     * https://www.kinomap.com/v2/terms
     * https://www.kinomap.com/v2/privacy
     */

    switch (path) {
      case 'dashboard':
      case 'compatibility':
      case 'dashboard/my-profile':
      case 'terms':
      case 'privacy':
        return `/${path}`;
      case 'register':
        window.location.href = environment.oauth.url + '/sign-up';
      default:
        return '/home';
    }
  }

  private getContentId(
    contentType: 'coaching' | 'watch',
    hashId: string
  ): Observable<number> {
    const endpointType: string =
      contentType === 'coaching'
        ? 'coaching/coachingByHashId'
        : 'scenic/videoByHashId';
    const endpoint: string = `${API_URL_V4}/${endpointType}`;
    const params: HttpParams = new HttpParams().set('hash_id', hashId);
    return this.http
      .get<any>(endpoint, { params })
      .pipe(map((response: any) => response.data.id));
  }

  redirectTo(url: string): void {
    this.router.navigateByUrl(url);
  }
}
